export function extractData(res: Response) {
  return res || { };
}
